import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { Routes } from '€lib/routing';

const PrivateRoute = ({ children, authenticated = false, ...rest }) => (
    <Route
        {...rest}
        render={({ location }) =>
            authenticated ? (
                children
            ) : (
                <Redirect
                    to={{
                        pathname: Routes.Login,
                        state: { from: location },
                    }}
                />
            )
        }
    />
);

export default PrivateRoute;
